import { TApplicationState } from '../../types/redux';

export function getHasProblems(state: TApplicationState): boolean {
  const {
    newbuilding: { hasProblems },
  } = state;

  if (!hasProblems) {
    return false;
  }

  return hasProblems;
}
